module.exports = __webpack_public_path__ + "static/media/los-scorecard-value-table.bcff3966.png";